import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    position: 'relative',
    height: '65vh',
    color: theme.palette.primary.contrastText,
  },
  imageContainer: ({ images }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    backgroundImage: images && `linear-gradient(rgba(0, 35, 75, 0.7), rgba(0, 35, 75, 0.7)), url(${images.lg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('xs')]: {
      backgroundImage: images && `linear-gradient(rgba(0, 35, 75, 0.7), rgba(0, 35, 75, 0.7)), url(${images.sm})`,
    },
  }),
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(21),
    padding: '0 32px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(8),
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    height: '150px',
    marginBottom: theme.spacing(7.5),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(4),
      height: '120px',
    },
  },
  halfCircle: {
    display: 'flex',
    position: 'absolute',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    bottom: 0,
    textAlign: 'center',
    width: '134px',
    height: '67px',
    borderTopLeftRadius: '100px',
    borderTopRightRadius: '100px',
    boxSizing: 'border-box',
    background: '#fff',
    [theme.breakpoints.down('xs')]: {
      width: 100,
      height: 100,
      bottom: '-70px',
    },
  },
  halfCircleArrow: {
    marginTop: '11px',
    fontSize: '1.25rem',
    color: theme.palette.primary.dark,
    [theme.breakpoints.down('xs')]: {
      fontSize: '1rem',
    },
  },
}))

export default useStyles
